
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("92t1P", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=es.95e2fc91.js.map
